import { memo } from 'react'
import { getToken } from '../../function/token';
import { ErrorToastContainer, SuccessToastContainer, WorningToastContainer } from '../../function/CustomFunction';
import domain from '../../../reusecomponent/domain';

function Payment({payment,setloder}) {

    const Pdfdownload = (orderid) =>{
        console.log(orderid);
        setloder(true);
        const myHeaders = new Headers();
        const access_token = getToken();
        myHeaders.append("Authorization", `Bearer ${access_token}`);
        const requestOptions = {
          method: "GET",
          headers: myHeaders,
          redirect: "follow"
        };
        
        fetch(`${domain()}/pdf/${orderid}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          setloder(false);
          if(result.status){
            const byteCharacters = atob(result.data);
            console.log(byteCharacters);
            const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });
    
            // Create a download link
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `${atob(atob(orderid))}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
    
            SuccessToastContainer(result.message);
          }else{
            ErrorToastContainer(result.message);
          }
          console.log(result)
        })
        .catch(error => {
          setloder(false);
          ErrorToastContainer("Internal Server Error");
        });
      
    }

    // Get status badge styling
    const getStatusBadge = (status) => {
      const statusInt = parseInt(status);
      if (statusInt === 1) {
        return (
          <span className="status-badge success py-2">
            <i className="fas fa-check-circle me-1"></i>
            Success
          </span>
        );
      } else if (statusInt === 0) {
        return (
          <span className="status-badge failed py-2">
            <i className="fas fa-times-circle me-1"></i>
            Failed
          </span>
        );
      } else {
        return (
          <span className="status-badge pending py-2">
            <i className="fas fa-clock me-1"></i>
            Pending
          </span>
        );
      }
    };

    // Format date and time
    const formatDateTime = (date, time) => {
      const dateObj = new Date(`${date} ${time}`);
      return dateObj.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    };

  return (
    <>
    <tr className="border-bottom" style={{ 
      transition: 'all 0.2s ease',
      backgroundColor: 'white',
      borderBottom: '1px solid #e9ecef'
    }}>
        <td className="py-2 px-4" style={{ verticalAlign: 'middle' }}>
          <div className="payment-order-id">
            #{payment.order_id}
          </div>
        </td>
        <td className="py-2 px-4" style={{ verticalAlign: 'middle' }}>
          <div className="payment-amount">
            ₹{payment.total_amount}
          </div>
        </td>
        <td className="py-2 px-4" style={{ verticalAlign: 'middle' }}>
          <div className="payment-utr">
              {payment.payment_type}
          </div>
        </td>
        <td className="py-2 px-4" style={{ verticalAlign: 'middle' }}>
          <div className="payment-utr">
            {payment.utr_no || 'N/A'}
          </div>
        </td>
        <td className="py-2 px-4 text-center" style={{ verticalAlign: 'middle' }}>
          {getStatusBadge(payment.status)}
        </td>
        <td className="py-2 px-4" style={{ verticalAlign: 'middle' }}>
          <div className="payment-message">
            {payment.message || 'No message'}
          </div>
        </td>
        <td className="py-2 px-4" style={{ verticalAlign: 'middle' }}>
          <div className="payment-date">
            {formatDateTime(payment.date, payment.time)}
          </div>
        </td>
        <td className="py-2 px-4 text-center" style={{ verticalAlign: 'middle' }}>
          <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              className="invoice-button"
              onClick={() => {
                payment.status ? Pdfdownload(btoa(btoa(payment.order_id))) : WorningToastContainer("Invoice Not Available");
              }}
              disabled={!payment.status}
              title={payment.status ? "Download Invoice" : "Invoice Not Available"}
            >
              Invoice
            </button>
          </div>
        </td>
    </tr>
  </>
  )
}

export default memo(Payment)
